import {CSSProperties} from "react";

interface IconButtonProps {
    icon: string;
    onClick(event: React.MouseEvent<HTMLButtonElement>): void;
    style?: CSSProperties | undefined;
    disabled?: boolean;
    title?: string;
}

function IconButton(props: IconButtonProps) {
    return (
        <button onClick={e => props.onClick(e)} style={props.style} disabled={props.disabled} title={props.title}>
            <span className={`fa-solid fa-${props.icon}`}/>
        </button>
    )
}

export default IconButton;